import { useState } from 'react';

export function useSwitchUser() {
  const [isVisible, setVisible] = useState(false);

  return {
    actions: {
      setVisible,
    },
    data: {
      isVisible,
    },
  };
}
